const LinkedinIcon = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.2469 1.5C15.939 1.5 16.5 2.06064 16.5 2.75309V15.2469C16.5 15.939 15.9394 16.5 15.2469 16.5H2.75309C2.06103 16.5 1.5 15.9394 1.5 15.2469L1.5 2.75309C1.5 2.06103 2.06064 1.5 2.75309 1.5L15.2469 1.5ZM11.6391 7.125C10.5746 7.125 9.84615 7.59552 9.52183 8.14219L9.46881 8.23937V7.21875H7.43756V14.4062H9.62506V10.9247C9.62506 9.75781 10.0547 9.01562 11.0876 9.01562C11.7999 9.01562 12.0987 9.6455 12.1234 10.7685L12.1251 10.9247V14.4062H14.3126V10.4366C14.3126 8.29312 13.7997 7.125 11.6391 7.125ZM5.87506 7.125H3.68756L3.68756 14.3125H5.87506V7.125ZM4.78125 3.375C4.00469 3.375 3.375 4.00469 3.375 4.78125C3.375 5.55781 4.00469 6.1875 4.78125 6.1875C5.55781 6.1875 6.1875 5.55781 6.1875 4.78125C6.1875 4.00469 5.55781 3.375 4.78125 3.375Z"
			fill="#A38550"
		/>
	</svg>
);
export default LinkedinIcon;
